<template>
  <div class="container">
    <van-swipe
      vertical
      class="outer-swiper"
      ref="outer-swiper"
      :loop="false"
      :show-indicators="false"
      :initial-swipe="0"
      :style="{ height: windowHeight }"
      @change="onSwiperChange"
    >
      <van-swipe-item>
        <div class="page-home">
          <img
            class="logo"
            src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/wow-white.png"
          />
          <div class="text-wrap">
            <div class="top">
              <div class="text1">音乐窝</div>
              <div class="text2">MusicWOW</div>
            </div>
            <div class="text3">音乐教育新未来</div>
            <div class="text4">产品介绍</div>
          </div>
          <div class="student-wrap">
            <img
              class="student"
              src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/homepage/student.png"
            />
            <img
              class="note1"
              src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/note1.png"
            />
            <img
              class="note2"
              src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/note2.png"
            />
            <img
              class="note3"
              src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/note3.png"
            />
            <img
              class="note4"
              src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/note4.png"
            />
            <img
              class="note5"
              src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/note5.png"
            />
          </div>
          <img
            class="bottom-arrow"
            src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/homepage/arrow.png"
          />
        </div>
      </van-swipe-item>
      <van-swipe-item>
        <div class="common-title-page">
          <img
            class="logo"
            src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/wow-white.png"
          />
          <div class="number">- 01 -</div>
          <div class="title1">全新</div>
          <div class="title2">音乐玩创理念</div>
          <div class="desc">
            行业全新玩创理念音乐教育品牌<br />学音乐～就是玩！
          </div>
          <img
            class="line"
            src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/heart-line.png"
          />
        </div>
      </van-swipe-item>
      <van-swipe-item>
        <div class="page1-1">
          <img
            class="logo"
            src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/wow-color.png"
          />
          <div class="title">全新音乐玩创理念</div>
          <div class="list-wrap">
            <div class="item">
              <div class="left color1">玩</div>
              <div class="right">
                是兴趣引导的源泉<br />也是感知快乐的原点，更是一种学习音乐的态度
              </div>
            </div>
            <div class="item">
              <div class="left color2">学</div>
              <div class="right">
                专业奠基，学有所得<br />专业、科学、系统的学习，夯实知识积累
              </div>
            </div>
            <div class="item">
              <div class="left color3">创</div>
              <div class="right">
                是底层素质塑造的自然发生<br />是以兴趣与专业为基础下的自我情感表达
              </div>
            </div>
          </div>
          <div class="bottom-text">
            <img
              class="arrow"
              src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/page1/green-arrow.png"
            />
            <div class="text">
              打破枯燥无味的学习方式<br />用玩的心态去学习音乐、享受音乐的快乐
            </div>
            <div class="tag">
              <img
                class="img"
                src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/page1/green-tips.png"
              />
              <span class="t">让教育回归本质</span>
            </div>
          </div>
          <img
            class="student-img"
            src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/page1/student1.png"
          />
        </div>
      </van-swipe-item>
      <van-swipe-item>
        <div class="page1-2">
          <img
            class="logo"
            src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/wow-color.png"
          />
          <div class="title">全新音乐玩创理念</div>
          <div class="text1">结合成长不同阶段的侧重点</div>
          <div class="text2">开展授课形式设计等系列工作</div>
          <div class="step-wrap">
            <div>
              <img
                class="img1"
                src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/page1/step1.png"
              />
            </div>
            <div>
              <img
                class="img2"
                src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/page1/arrow-down1.png"
              />
            </div>
            <div>
              <img
                class="img3"
                src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/page1/step2.png"
              />
            </div>
            <div>
              <img
                class="img4"
                src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/page1/arrow-down2.png"
              />
            </div>
            <div>
              <img
                class="img5"
                src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/page1/step3.png"
              />
            </div>
          </div>
        </div>
      </van-swipe-item>
      <van-swipe-item>
        <div class="common-title-page">
          <img
            class="logo"
            src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/wow-white.png"
          />
          <div class="number">- 02 -</div>
          <div class="title1">综合&可闭环</div>
          <div class="title2">玩创课程体系</div>
          <div class="desc">自主研发玩创课程体系<br />可闭环成果呈现</div>
          <img
            class="line"
            src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/heart-line.png"
          />
        </div>
      </van-swipe-item>
      <van-swipe-item>
        <div class="page2-1">
          <img
            class="logo"
            src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/wow-color.png"
          />
          <img
            class="base-pro-img"
            src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/page2/base-pro.png"
          />
          <div class="bottom-text">
            课程从BASE启蒙到PRO进阶逐步递进<br />构建完整课程体系，确保全年龄段覆盖
          </div>
        </div>
      </van-swipe-item>
      <van-swipe-item>
        <div class="page2-2">
          <img
            class="logo"
            src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/wow-color.png"
          />
          <div class="title">玩创课程体系</div>
          <div class="course-list">
            <img
              class="note1"
              src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/green-note2.png"
            />
            <img
              class="note2"
              src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/green-note1.png"
            />
            <img
              class="note3"
              src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/green-note3.png"
            />
            <div class="item">
              <div class="tag">
                <div class="text">主打科目-钢琴</div>
              </div>
              <div class="bg">
                <img
                  class="student-img1"
                  src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/page2/student1.png"
                />
                <div class="text1">更适合孩子的钢琴课</div>
                <div class="text2">
                  课程围绕音乐学习体验性、实践性、创造性特点<br />与课程专属IP一起<br />通过生动有趣的动画故事和AI游戏<br />沉浸式互动学习
                </div>
              </div>
            </div>
            <div class="item">
              <div class="tag">
                <div class="text">主打科目-爵士鼓</div>
              </div>
              <div class="bg">
                <img
                  class="student-img2"
                  src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/page2/student2.png"
                />
                <div class="text1">爵士鼓原来这么好玩</div>
                <div class="text2">
                  爵士鼓课程综合世界主流教材的优点编写而成<br />让学员更好的学懂乐理知识<br />更熟练的掌握乐器演奏技法<br />为日后打下良好的基础
                </div>
              </div>
            </div>
            <div class="item">
              <div class="tag">
                <div class="text">主打科目-吉他</div>
              </div>
              <div class="bg">
                <img
                  class="student-img3"
                  src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/page2/student3.png"
                />
                <div class="text1">用吉他打开音乐新视界</div>
                <div class="text2">
                  从最简单的单音演奏开始，感受弹奏音乐的乐趣<br />让兴趣引导学员<br />稳扎稳打地学习并主动去探索吉他世界的奥义
                </div>
              </div>
            </div>
          </div>
        </div>
      </van-swipe-item>
      <van-swipe-item>
        <div class="page2-3">
          <img
            class="logo"
            src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/wow-color.png"
          />
          <img
            class="main-student"
            src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/page2/ai-student1.png"
          />
          <div class="age-wrap">
            <img
              class="age-img"
              src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/light-green-tips.png"
            />
            <span class="text">3-6岁</span>
          </div>
          <div class="main-title">音乐素养AI</div>
          <div class="sub-title">EARLY CHILDHOOD<br />MUSIC WITH AI</div>
          <div class="common-video-button" @click="showVideo('ai')">
            <div class="border1"></div>
            <div class="border2"></div>
            <div class="border3"></div>
            <div class="content">
              <van-icon name="play" />
              <span class="text">查看视频</span>
            </div>
          </div>
          <div class="group-type">
            <div class="item">
              <span class="dot"></span>
              <span class="text"
                >上课形式<span class="num">3-6人</span>集体班</span
              >
            </div>
            <img
              class="note"
              src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/green-note1.png"
            />
          </div>
          <div class="main-desc">
            <div class="title">
              <img
                class="img"
                src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/green-tips-long.png"
              />
              <span class="text">玩音乐 从这里开始</span>
            </div>
            <div class="desc">
              音乐素养AI课专为3-6岁孩子设计,包括<span class="green"
                >基础乐理、乐感培养、音乐常识等内容</span
              >让孩子在探索音乐,玩音乐的过程中达到教学目标,享受音乐带来的快乐和成就
            </div>
            <img
              class="line"
              src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/page2/line-yellow1.png"
            />
          </div>
          <div class="course-wrap">
            <div class="tag">
              <img
                class="img"
                src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/green-tips-short.png"
              />
              <span class="text">课程优势</span>
            </div>
            <div class="list">
              <div class="item">
                <div class="title">
                  <img
                    class="icon"
                    src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/icon/icon1.png"
                  />
                  <span class="text">趣味化</span>
                </div>
                <div class="desc">
                  卡通动画故事+AI游戏通关练习，玩乐中学习音乐
                </div>
              </div>
              <div class="item">
                <div class="title">
                  <img
                    class="icon"
                    src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/icon/icon2.png"
                  />
                  <span class="text">益智化</span>
                </div>
                <div class="desc">音乐知识融入课程各个环节，提升音乐素养</div>
              </div>
              <div class="item">
                <div class="title">
                  <img
                    class="icon"
                    src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/icon/icon3.png"
                  />
                  <span class="text">强体验</span>
                </div>
                <div class="desc">“Al+音频算法”技术，学习更有趣</div>
              </div>
              <div class="item">
                <div class="title">
                  <img
                    class="icon"
                    src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/icon/icon4.png"
                  />
                  <span class="text">强互动</span>
                </div>
                <div class="desc">多种乐器+音乐，带动身体律动</div>
              </div>
            </div>
          </div>
          <div class="result-wrap">
            <div class="tag">
              <img
                class="img"
                src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/green-tips-short.png"
              />
              <span class="text">课程收获</span>
            </div>
            <div class="list">
              <div class="item">
                <van-icon name="success" />
                <span class="text">基础乐理知识、基础视唱和练耳能力</span>
              </div>
              <div class="item">
                <van-icon name="success" />
                <span class="text">了解各种乐器和音乐风格等常识</span>
              </div>
              <div class="item">
                <van-icon name="success" />
                <span class="text"
                  >培养音乐兴趣，提升艺术的美感能力，享受音乐<br />生活、培养创编能力</span
                >
              </div>
              <div class="item">
                <van-icon name="success" />
                <span class="text"
                  >提升各项软能力，为之后的音乐之路奠定基础</span
                >
              </div>
            </div>
            <img
              class="bottom-img1"
              src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/page2/ai-student3.png"
            />
            <img
              class="bottom-img2"
              src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/page2/ai-student2.png"
            />
            <img
              class="line-red"
              src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/page2/line-red1.png"
            />
            <img
              class="line-yellow"
              src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/page2/line-yellow3.png"
            />
          </div>
        </div>
      </van-swipe-item>
      <van-swipe-item>
        <div class="page2-4">
          <img
            class="logo"
            src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/wow-color.png"
          />
          <img
            class="main-student"
            src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/page2/piano-student1.png"
          />
          <div class="age-wrap">
            <img
              class="note1"
              src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/green-note3.png"
            />
            <img
              class="note2"
              src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/green-note4.png"
            />
            <img
              class="note3"
              src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/green-note1.png"
            />
            <img
              class="age-img"
              src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/light-green-tips.png"
            />
            <span class="text">6岁+</span>
          </div>
          <div class="main-title">钢琴</div>
          <div class="sub-title">PIANO</div>
          <div class="common-video-button" @click="showVideo('piano')">
            <div class="border1"></div>
            <div class="border2"></div>
            <div class="border3"></div>
            <div class="content">
              <van-icon name="play" />
              <span class="text">查看视频</span>
            </div>
          </div>
          <div class="group-type">
            <div class="item">
              <span class="dot"></span>
              <span class="text"
                >练习课上课形式：<span class="num">1v1</span></span
              >
            </div>
            <div class="item">
              <span class="dot"></span>
              <span class="text"
                >综合课上课形式<span class="num">3-6人</span>集体班</span
              >
            </div>
          </div>
          <div class="main-desc">
            <div class="title">
              <img
                class="img"
                src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/green-tips-long.png"
              />
              <span class="text">最适合孩子的钢琴课</span>
            </div>
            <div class="desc">
              课程涵盖了2-3级考纲知识点,在掌握乐理知识及钢琴演奏技能技巧的同时，体验多种音乐风格,<span
                class="green"
                >注重听觉训练和视奏能力,音乐窝特色音乐玩创环节,让小朋友热爱音乐,享受音乐</span
              >
            </div>
          </div>
          <div class="course-wrap">
            <img
              class="line"
              src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/page2/line-blue.png"
            />
            <div class="tag">
              <img
                class="img"
                src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/green-tips-short.png"
              />
              <span class="text">课程优势</span>
            </div>
            <div class="list">
              <div class="item">
                <img
                  class="icon"
                  src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/icon/icon1.png"
                />
                <div class="text">
                  <div class="title">趣味音乐玩创</div>
                  <div class="desc">
                    旋律创作&即兴伴奏,流行古典两不误
                  </div>
                </div>
              </div>
              <div class="item">
                <img
                  class="icon"
                  src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/icon/icon5.png"
                />
                <div class="text">
                  <div class="title">大智慧</div>
                  <div class="desc">
                    乐理/听力/视唱/视奏/音乐欣赏/技巧/合奏/弹唱/即兴
                  </div>
                </div>
              </div>
              <div class="item">
                <img
                  class="icon"
                  src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/icon/icon6.png"
                />
                <div class="text">
                  <div class="title">趣味音乐故事</div>
                  <div class="desc">
                    传统节日/乐队巡演/日常趣事
                  </div>
                </div>
              </div>
              <div class="item">
                <img
                  class="icon"
                  src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/icon/icon7.png"
                />
                <div class="text">
                  <div class="title">曲目丰富多样</div>
                  <div class="desc">
                    古典/流行/爵士/儿歌/民歌/民谣,选曲适龄、好听，跟随奏沉浸式感受
                  </div>
                </div>
              </div>
              <div class="item">
                <img
                  class="icon"
                  src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/icon/icon8.png"
                />
                <div class="text">
                  <div class="title">智能互动课件</div>
                  <div class="desc">
                    音频/素材互动/人练习讲解/人演奏示范，知识吸收更准确，结合教学机玩中学
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="result-wrap">
            <div class="tag">
              <img
                class="img"
                src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/green-tips-short.png"
              />
              <span class="text">课程收获</span>
            </div>
            <div class="list">
              <div class="item">
                <van-icon name="success" />
                <span class="text"
                  ><span class="green">基础知识:</span
                  >掌握大谱表对应全键盘的识谱能力，更复杂的节奏型组合</span
                >
              </div>
              <div class="item">
                <van-icon name="success" />
                <span class="text"
                  ><span class="green">演奏技巧:</span
                  >80首必弹曲目,40多首挑战曲目，30多首玩创曲目</span
                >
              </div>
              <div class="item">
                <van-icon name="success" />
                <span class="text"
                  ><span class="green">音乐玩创:</span
                  >用更复杂的节奏律动,在更多音阶范围内进行即兴创作</span
                >
              </div>
            </div>
            <img
              class="bottom-img1"
              src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/page2/piano-student3.png"
            />
            <img
              class="bottom-img2"
              src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/page2/piano-student2.png"
            />
            <img
              class="line-red"
              src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/page2/line-red2.png"
            />
            <img
              class="line-yellow"
              src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/page2/line-yellow2.png"
            />
          </div>
        </div>
      </van-swipe-item>
      <van-swipe-item>
        <page2part5 @click-video="(type) => showVideo(type)"></page2part5>
      </van-swipe-item>
      <van-swipe-item>
        <page2part6 @click-video="(type) => showVideo(type)"></page2part6>
      </van-swipe-item>
      <van-swipe-item>
        <page2part7 @click-video="(type) => showVideo(type)"></page2part7>
      </van-swipe-item>
      <van-swipe-item>
        <page2part8></page2part8>
      </van-swipe-item>
      <van-swipe-item>
        <page2part9></page2part9>
      </van-swipe-item>
      <van-swipe-item>
        <div class="common-title-page">
          <img
            class="logo"
            src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/wow-white.png"
          />
          <div class="number">- 03 -</div>
          <div class="title1">智能数字化</div>
          <div class="title2">赋能平台</div>
          <div class="desc">
            好的产品决定收入<br />好的工具能降低成本，使利润最大化<br />三大数字管理利器，让运营更降本、更高效
          </div>
          <img
            class="line"
            src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/heart-line.png"
          />
        </div>
      </van-swipe-item>
      <van-swipe-item>
        <page3part1></page3part1>
      </van-swipe-item>
      <van-swipe-item>
        <page3part2></page3part2>
      </van-swipe-item>
      <van-swipe-item>
        <page3part3></page3part3>
      </van-swipe-item>
      <van-swipe-item>
        <page3part4></page3part4>
      </van-swipe-item>
      <van-swipe-item>
        <div class="common-title-page">
          <img
            class="logo"
            src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/wow-white.png"
          />
          <div class="number">- 04 -</div>
          <div class="title1">多元</div>
          <div class="title2">盈利模型</div>
          <div class="desc">复合盈利渠道<br />多形式创收</div>
          <img
            class="line"
            src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/heart-line.png"
          />
        </div>
      </van-swipe-item>
      <van-swipe-item>
        <page4></page4>
      </van-swipe-item>
      <van-swipe-item>
        <div class="page-end">
          <img
            class="logo"
            src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/wow-white.png"
          />
          <div class="main-wrap">
            <img
              class="note1"
              src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/note1.png"
            />
            <img
              class="note2"
              src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/note3.png"
            />
            <img
              class="note3"
              src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/note4.png"
            />
            <img
              class="note4"
              src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/note5.png"
            />
            <img
              class="end-logo"
              src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/end-logo.png"
            />
            <div class="phone-text">
              <div>合伙人招募热线</div>
              <div class="small">400-661-8883</div>
            </div>
          </div>
          <div class="qr-code-wrap">
            <img
              class="qr-code"
              src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/end-qr.png"
            />
            <div class="text-wrap">
              <div class="text1">国内全新音乐玩创品牌</div>
              <div class="line"></div>
              <div class="text2">
                音乐窝官网: www.musicwow.com<br />商务合作:
                business@musicwow.com<br />音乐窝总部地址: 广州市海珠区
                广东现代广告创意中心503
              </div>
            </div>
          </div>
        </div>
      </van-swipe-item>
    </van-swipe>
    <van-dialog
      v-model="videoVisible"
      title=""
      :showConfirmButton="false"
      :showCancelButton="false"
      :closeOnClickOverlay="true"
      @close="handleVideoClose"
      width="100vw"
    >
      <video
        id="main-course-video"
        controls
        :src="videoUrl"
        style="width: 100vw;height: auto;"
        autoplay
        poster="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/video-poster.png"
      ></video>
    </van-dialog>
    <img
      v-if="currentIndex !== 0"
      class="back-top"
      @click="backTop"
      src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/back-top.png"
    />
  </div>
</template>
<script>
import page2part5 from "./page2part5.vue";
import page2part6 from "./page2part6.vue";
import page2part7 from "./page2part7.vue";
import page2part8 from "./page2part8.vue";
import page2part9 from "./page2part9.vue";
import page3part1 from "./page3part1.vue";
import page3part2 from "./page3part2.vue";
import page3part3 from "./page3part3.vue";
import page3part4 from "./page3part4.vue";
import page4 from "./page4.vue";
export default {
  components: {
    page2part5,
    page2part6,
    page2part7,
    page2part8,
    page2part9,
    page3part1,
    page3part2,
    page3part3,
    page3part4,
    page4,
  },
  data() {
    return {
      videoVisible: false,
      videoUrl: "",
      windowHeight: "100vh",
      currentIndex: 0,
    };
  },
  mounted() {
    // alert(window.innerHeight);
    // alert(window.innerWidth);
    document.title = "学音乐~就是玩！";
    this.swiperResize();
    window.addEventListener("resize", this.swiperResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.swiperResize);
  },
  methods: {
    swiperResize() {
      const isIos = !!navigator.userAgent.match(
        /\(i[^;]+;( U;)? CPU.+Mac OS X/
      ); //ios终端
      if (isIos) {
        this.windowHeight = window.innerHeight + "px";
      } else {
        this.windowHeight = "100vh";
      }
      this.$nextTick(() => {
        this.$refs["outer-swiper"].resize();
      });
    },
    showVideo(type) {
      if (type === "ai") {
        this.videoUrl =
          "https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/video/ai.mp4";
      }
      if (type === "band") {
        this.videoUrl =
          "https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/video/band.mp4";
      }
      if (type === "drums") {
        this.videoUrl =
          "https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/video/drum.mp4";
      }
      if (type === "guitar") {
        this.videoUrl =
          "https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/video/guitar.mp4";
      }
      if (type === "piano") {
        this.videoUrl =
          "https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/video/piano.mp4";
      }
      if (type === "uk") {
        this.videoUrl =
          "https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/video/uk.mp4";
      }
      this.videoVisible = true;
    },
    handleVideoClose() {
      const video = document.getElementById("main-course-video");
      if (video) {
        video.pause();
      }
    },
    onSwiperChange(index) {
      this.currentIndex = index;
    },
    backTop() {
      this.$refs["outer-swiper"].swipeTo(0);
    },
  },
};
</script>
<style scoped lang="scss">
@function perS($w) {
  @return ($w/375) * 100vw;
}
.container {
  text-align: left;
  .outer-swiper {
    .van-swipe-item {
      height: 100%;
    }
  }
  .van-dialog {
    background-color: rgba(0, 0, 0, 0);
    border-radius: 0;
  }
  .back-top {
    width: perS(30);
    height: auto;
    position: fixed;
    bottom: perS(10);
    right: perS(10);
    z-index: 1000;
  }
}
.page-home {
  position: relative;
  overflow: hidden;
  width: 100vw;
  height: 100%;
  background-image: url(https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/bg-green.png);
  background-size: 100% auto;
  background-repeat: no-repeat;
  .logo {
    width: perS(90);
    height: auto;
    position: absolute;
    top: 8vh;
    right: perS(28);
  }
  .text-wrap {
    margin: 18vh 0 0 perS(20);
    .top {
      display: flex;
      margin-bottom: perS(20);
      .text1 {
        font-size: perS(34);
        color: #fff;
        font-weight: 500;
        line-height: perS(34);
      }
      .text2 {
        font-size: perS(25);
        color: #76995d;
        font-weight: 500;
        line-height: perS(25);
        margin-left: perS(5);
      }
    }
    .text3 {
      font-size: perS(41);
      color: #fff;
      font-weight: 700;
      line-height: perS(40);
    }
    .text4 {
      font-size: perS(34);
      color: #fff;
      font-weight: 700;
      line-height: perS(50);
    }
  }
  .student-wrap {
    position: relative;
    text-align: right;
    margin: perS(0) perS(-55) 0 0;
    .student {
      width: perS(305);
      height: auto;
    }
    .note1 {
      width: perS(14);
      height: auto;
      position: absolute;
      top: perS(-20);
      left: perS(252);
    }
    .note2 {
      width: perS(22);
      height: auto;
      position: absolute;
      top: perS(60);
      left: perS(45);
    }
    .note3 {
      width: perS(30);
      height: auto;
      position: absolute;
      top: perS(25);
      left: perS(160);
    }
    .note4 {
      width: perS(15);
      height: auto;
      position: absolute;
      top: perS(240);
      left: perS(70);
    }
    .note5 {
      width: perS(35);
      height: auto;
      position: absolute;
      top: perS(150);
      left: perS(90);
    }
  }
  .bottom-arrow {
    width: perS(100);
    height: auto;
    position: absolute;
    bottom: perS(10);
    left: perS(140);
    animation: homeArrowSwing 1.2s linear infinite;
  }
}
.common-title-page {
  width: 100vw;
  height: 100%;
  overflow: hidden;
  position: relative;
  background-color: #46b13a;
  text-align: left;
  .logo {
    width: perS(90);
    height: auto;
    position: absolute;
    top: 7vh;
    right: perS(28);
  }
  .number {
    font-size: perS(40);
    color: #fff;
    font-weight: 500;
    margin: 19vh 0 0 perS(40);
  }
  .title1 {
    font-size: perS(38);
    color: #fff;
    font-weight: 700;
    margin: perS(15) 0 0 perS(40);
  }
  .title2 {
    font-size: perS(34);
    color: #fff;
    font-weight: 700;
    margin: perS(0) 0 0 perS(40);
  }
  .desc {
    font-size: perS(14);
    color: #fff;
    font-weight: 400;
    margin: perS(15) 0 0 perS(40);
  }
  .line {
    width: perS(671);
    height: auto;
    margin: perS(80) 0 0 perS(-80);
  }
}
.page1-1 {
  position: relative;
  overflow: hidden;
  width: 100vw;
  height: 100%;
  background-image: url(https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/page1/gray-bg.png);
  background-size: 101% auto;
  background-position: left bottom;
  background-repeat: no-repeat;
  .logo {
    width: perS(90);
    height: auto;
    position: absolute;
    top: 8vh;
    right: perS(28);
  }
  .title {
    font-size: perS(20);
    font-weight: 900;
    line-height: perS(40);
    color: #000;
    margin: 10vh 0 perS(40) perS(25);
  }
  .list-wrap {
    margin-left: perS(25);
    .item {
      display: flex;
      align-items: center;
      margin-bottom: perS(20);
      .left {
        font-size: perS(40);
        font-weight: 500;
        line-height: perS(40);
        border-right: perS(2) solid;
        padding: perS(3) perS(10) perS(3) 0;
        margin-right: perS(12);
        &.color1 {
          color: #8ac221;
          border-color: #8ac221;
        }
        &.color2 {
          color: #45b23a;
          border-color: #45b23a;
        }
        &.color3 {
          color: #ea4f1a;
          border-color: #ea4f1a;
        }
      }
      .right {
        text-align: left;
        font-size: perS(11);
        font-weight: 500;
        line-height: perS(21);
        color: #000;
      }
    }
  }
  .bottom-text {
    display: flex;
    align-items: center;
    margin-left: perS(15);
    position: relative;
    .arrow {
      width: perS(36);
      height: auto;
      margin-right: perS(8);
    }
    .text {
      font-size: perS(13);
      font-weight: 700;
      line-height: perS(22);
      color: #000;
      font-style: italic;
    }
    .tag {
      position: absolute;
      top: perS(60);
      right: perS(10);
      .img {
        width: perS(139);
        height: auto;
      }
      .t {
        font-size: perS(17);
        font-weight: 700;
        line-height: perS(40);
        color: #fff;
        position: absolute;
        top: perS(8);
        left: perS(10);
        transform: rotate(-7.5deg);
      }
    }
  }
  .student-img {
    width: perS(361);
    height: auto;
    margin-left: perS(15);
  }
}
.page1-2 {
  position: relative;
  overflow: hidden;
  width: 100vw;
  height: 100%;
  background-image: url(https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/bg-gray.png);
  background-size: 100% auto;
  background-repeat: no-repeat;
  .logo {
    width: perS(90);
    height: auto;
    position: absolute;
    top: 8vh;
    right: perS(28);
  }
  .title {
    font-size: perS(20);
    font-weight: 900;
    line-height: perS(40);
    color: #000;
    margin: 11vh 0 perS(50) perS(25);
  }
  .text1 {
    text-align: center;
    font-size: perS(17);
    font-weight: 700;
    line-height: perS(21);
    color: #46b13a;
  }
  .text2 {
    text-align: center;
    font-size: perS(17);
    font-weight: 700;
    line-height: perS(26);
    color: #000;
  }
  .step-wrap {
    margin-top: perS(50);
    text-align: center;
    .img1 {
      width: perS(277);
      height: auto;
    }
    .img2 {
      width: perS(70);
      height: auto;
      margin: perS(6) 0;
    }
    .img3 {
      width: perS(277);
      height: auto;
    }
    .img4 {
      width: perS(70);
      height: auto;
      margin: perS(6) 0;
    }
    .img5 {
      width: perS(277);
      height: auto;
    }
  }
}
.page2-1 {
  .logo {
    width: perS(90);
    height: auto;
    position: absolute;
    top: 8vh;
    right: perS(28);
  }
  .base-pro-img {
    width: perS(326);
    height: auto;
    margin: 12vh auto 0 auto;
    display: block;
  }
  .bottom-text {
    text-align: right;
    font-size: perS(12);
    font-weight: 500;
    line-height: perS(21);
    color: #000;
    margin-right: perS(20);
  }
}
.page2-2 {
  position: relative;
  overflow: hidden;
  width: 100vw;
  height: 100%;
  background-image: url(https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/bg-light.png);
  background-size: 100% auto;
  background-repeat: no-repeat;
  .logo {
    width: perS(90);
    height: auto;
    position: absolute;
    top: 8vh;
    right: perS(28);
  }
  .title {
    font-size: perS(20);
    font-weight: 900;
    line-height: perS(40);
    color: #000;
    margin: 9vh 0 perS(50) perS(25);
  }
  .course-list {
    position: relative;
    .item {
      position: relative;
      .tag {
        position: absolute;
        top: perS(-30);
        left: perS(25);
        width: perS(113);
        height: perS(51);
        background-image: url(https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/black-tips.png);
        background-size: 100% 100%;
        background-repeat: no-repeat;
        z-index: 100;
        .text {
          color: #fff;
          font-size: perS(14);
          font-weight: 700;
          line-height: perS(22);
          transform: rotate(-8deg);
          margin: perS(10.5) 0 0 perS(11);
          white-space: nowrap;
        }
      }
      .bg {
        overflow: hidden;
        position: relative;
        height: perS(140);
        width: perS(308);
        border-radius: perS(14);
        background-color: #fff;
        margin: perS(30) auto perS(50) auto;
        box-shadow: 0px perS(5) perS(10) rgba(99, 125, 63, 0.24);
        .student-img1 {
          width: perS(153);
          height: auto;
          position: absolute;
          left: 0;
          bottom: 0;
        }
        .student-img2 {
          width: perS(145);
          height: auto;
          position: absolute;
          left: 0;
          bottom: 0;
        }
        .student-img3 {
          width: perS(133);
          height: auto;
          position: absolute;
          left: perS(-7);
          bottom: 0;
        }
        .text1 {
          text-align: right;
          position: relative;
          z-index: 101;
          font-size: perS(21);
          font-weight: 700;
          line-height: perS(21);
          color: #46b13a;
          margin: perS(20) perS(15) perS(10) 0;
        }
        .text2 {
          text-align: right;
          position: relative;
          z-index: 101;
          font-size: perS(8);
          font-weight: 400;
          line-height: perS(15);
          color: #000;
          margin: 0 perS(15) 0 0;
        }
      }
    }
    .note1 {
      width: perS(45);
      height: auto;
      position: absolute;
      top: perS(108);
      left: perS(200);
      z-index: 200;
    }
    .note2 {
      width: perS(27);
      height: auto;
      position: absolute;
      top: perS(300);
      left: perS(320);
      z-index: 200;
    }
    .note3 {
      width: perS(44);
      height: auto;
      position: absolute;
      top: perS(385);
      left: perS(-5);
      z-index: 200;
    }
  }
}
.page2-3 {
  position: relative;
  overflow: hidden;
  width: 100vw;
  height: 100%;
  background-image: url(https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/bg-light.png);
  background-size: 100% auto;
  background-repeat: no-repeat;
  .logo {
    width: perS(90);
    height: auto;
    position: absolute;
    top: 8vh;
    right: perS(28);
    z-index: 100;
  }
  .main-student {
    width: perS(252);
    height: auto;
    position: absolute;
    top: 12vh;
    right: perS(-12);
  }
  .age-wrap {
    position: relative;
    margin: 7vh 0 perS(10) perS(25);
    .age-img {
      width: perS(62);
      height: auto;
    }
    .text {
      font-size: perS(18);
      line-height: perS(20);
      font-weight: 900;
      color: #fff;
      transform: rotate(-7deg);
      position: absolute;
      top: perS(6);
      left: perS(7);
    }
  }
  .main-title {
    position: relative;
    color: #46b13a;
    margin: 0 0 0 perS(25);
    font-size: perS(40);
    line-height: perS(40);
    font-weight: 900;
  }
  .sub-title {
    position: relative;
    color: #000;
    margin: 0 0 0 perS(25);
    font-size: perS(20);
    line-height: perS(20);
    font-weight: 900;
  }
  .group-type {
    margin: perS(8) 0 0 perS(25);
    position: relative;
    .item {
      .dot {
        display: inline-block;
        width: perS(5);
        height: perS(5);
        border-radius: 50%;
        background-color: #46b13a;
        margin-right: perS(4);
      }
      .text {
        color: #000;
        font-size: perS(9);
        line-height: perS(23);
        font-weight: 500;
        .num {
          font-size: perS(12);
          font-weight: 700;
        }
      }
    }
    .note {
      width: perS(19);
      height: auto;
      position: absolute;
      top: perS(10);
      left: perS(120);
    }
  }
  .main-desc {
    position: relative;
    margin: perS(8) perS(25) 0 perS(25);
    .title {
      position: relative;
      .img {
        width: perS(117);
        height: auto;
      }
      .text {
        font-size: perS(12);
        line-height: perS(20);
        font-weight: 900;
        color: #fff;
        transform: rotate(-7deg);
        position: absolute;
        top: perS(9.5);
        left: perS(7);
      }
    }
    .desc {
      background-color: #fff;
      margin: perS(-11) 0 0 0;
      padding: perS(10) perS(12);
      border-radius: perS(14);
      font-size: perS(8);
      line-height: perS(13);
      font-weight: 500;
      color: #000;
      box-shadow: 0 1px 2px #eee;
      .green {
        color: #46b13a;
        font-weight: 700;
      }
    }
    .line {
      position: absolute;
      right: perS(-5);
      bottom: perS(-10);
      width: perS(59);
      height: auto;
    }
  }
  .course-wrap {
    position: relative;
    margin: perS(12) perS(25) 0 perS(25);
    .tag {
      position: relative;
      margin-bottom: perS(5);
      .img {
        width: perS(70);
        height: auto;
      }
      .text {
        font-size: perS(12);
        line-height: perS(20);
        font-weight: 900;
        color: #fff;
        transform: rotate(-7deg);
        position: absolute;
        top: perS(6.5);
        left: perS(10);
      }
    }
    .list {
      display: flex;
      justify-content: space-between;
      .item {
        padding: perS(8);
        border-radius: perS(14);
        background-color: #fff;
        width: perS(76);
        box-shadow: 0px perS(5) perS(10) rgba(99, 125, 63, 0.24);
        .title {
          display: flex;
          align-items: center;
          .icon {
            width: perS(23);
            height: auto;
            margin-right: perS(2);
          }
          .text {
            font-size: perS(13);
            font-weight: 900;
            line-height: perS(11);
            color: #000;
            white-space: nowrap;
          }
        }
        .desc {
          font-size: perS(7);
          font-weight: 400;
          line-height: perS(10);
          color: #000;
          margin-top: perS(8);
        }
      }
    }
  }
  .result-wrap {
    margin: perS(30) 0 0 perS(25);
    position: relative;
    .tag {
      position: relative;
      margin-bottom: perS(5);
      .img {
        width: perS(70);
        height: auto;
      }
      .text {
        font-size: perS(12);
        line-height: perS(20);
        font-weight: 900;
        color: #fff;
        transform: rotate(-7deg);
        position: absolute;
        top: perS(6.5);
        left: perS(10);
      }
    }
    .list {
      .item {
        display: flex;
        .van-icon {
          margin-right: perS(8);
        }
        .text {
          font-size: perS(8);
          line-height: perS(16);
          font-weight: 500;
          color: #000;
        }
      }
    }
    .bottom-img1 {
      position: absolute;
      width: perS(106);
      height: auto;
      right: perS(40);
      top: perS(68);
    }
    .bottom-img2 {
      position: absolute;
      width: perS(122);
      height: auto;
      right: perS(40);
      top: perS(-5);
    }
    .line-red {
      position: absolute;
      width: perS(66);
      height: auto;
      right: perS(-5);
      top: perS(96);
    }
    .line-yellow {
      position: absolute;
      width: perS(23);
      height: auto;
      right: perS(164);
      top: perS(10);
    }
  }
}
.page2-4 {
  position: relative;
  overflow: hidden;
  width: 100vw;
  height: 100%;
  background-image: url(https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/bg-light.png);
  background-size: 100% auto;
  background-repeat: no-repeat;
  .logo {
    width: perS(90);
    height: auto;
    position: absolute;
    top: 8vh;
    right: perS(28);
    z-index: 100;
  }
  .main-student {
    width: perS(401);
    height: auto;
    position: absolute;
    top: 13vh;
    left: perS(-40);
  }
  .age-wrap {
    position: relative;
    margin: 8vh 0 perS(10) perS(25);
    .note1 {
      width: perS(30);
      height: auto;
      position: absolute;
      top: perS(70);
      left: perS(100);
      z-index: 100;
      transform: rotate(35deg);
    }
    .note2 {
      width: perS(11);
      height: auto;
      position: absolute;
      top: perS(110);
      left: perS(310);
      z-index: 100;
    }
    .note3 {
      width: perS(19);
      height: auto;
      position: absolute;
      top: perS(190);
      left: perS(265);
      z-index: 100;
    }
    .age-img {
      width: perS(62);
      height: auto;
    }
    .text {
      font-size: perS(18);
      line-height: perS(20);
      font-weight: 900;
      color: #fff;
      transform: rotate(-7deg);
      position: absolute;
      top: perS(6);
      left: perS(8);
    }
  }
  .main-title {
    position: relative;
    color: #46b13a;
    margin: 0 0 0 perS(25);
    font-size: perS(40);
    line-height: perS(40);
    font-weight: 900;
  }
  .sub-title {
    position: relative;
    color: #000;
    margin: 0 0 0 perS(25);
    font-size: perS(20);
    line-height: perS(20);
    font-weight: 900;
  }
  .group-type {
    margin: perS(8) 0 0 perS(25);
    position: relative;
    .item {
      .dot {
        display: inline-block;
        width: perS(5);
        height: perS(5);
        border-radius: 50%;
        background-color: #46b13a;
        margin-right: perS(4);
      }
      .text {
        color: #000;
        font-size: perS(9);
        line-height: perS(23);
        font-weight: 500;
        .num {
          font-size: perS(12);
          font-weight: 700;
        }
      }
    }
  }
  .main-desc {
    position: relative;
    margin: perS(-4) perS(25) 0 perS(25);
    .title {
      position: relative;
      .img {
        width: perS(117);
        height: auto;
      }
      .text {
        font-size: perS(12);
        line-height: perS(20);
        font-weight: 900;
        color: #fff;
        transform: rotate(-7deg);
        position: absolute;
        top: perS(9.5);
        left: perS(7);
      }
    }
    .desc {
      background-color: #fff;
      margin: perS(-11) 0 0 0;
      padding: perS(10) perS(12);
      border-radius: perS(14);
      font-size: perS(8);
      line-height: perS(13);
      font-weight: 500;
      color: #000;
      box-shadow: 0 1px 2px #eee;
      .green {
        color: #46b13a;
        font-weight: 700;
      }
    }
  }
  .course-wrap {
    position: relative;
    margin: perS(8) perS(25) 0 perS(25);
    .line {
      position: absolute;
      right: perS(-34);
      top: perS(18);
      width: perS(77);
      height: auto;
    }
    .tag {
      position: relative;
      margin-bottom: perS(-5);
      .img {
        width: perS(70);
        height: auto;
      }
      .text {
        font-size: perS(12);
        line-height: perS(20);
        font-weight: 900;
        color: #fff;
        transform: rotate(-7deg);
        position: absolute;
        top: perS(6.5);
        left: perS(10);
      }
    }
    .list {
      padding: perS(12);
      border-radius: perS(14);
      background-color: #fff;
      box-shadow: 0 1px 2px #eee;
      .item {
        display: inline-flex;
        vertical-align: top;
        align-items: start;
        width: 50%;
        margin-bottom: perS(10);
        &:last-child {
          margin-bottom: 0;
        }
        .icon {
          width: perS(23);
          height: auto;
          margin-right: perS(4);
        }
        .text {
          .title {
            font-size: perS(13);
            font-weight: 900;
            line-height: perS(11);
            color: #000;
          }
          .desc {
            width: perS(128);
            font-size: perS(7);
            font-weight: 400;
            line-height: perS(10);
            color: #000;
            margin-top: perS(6);
          }
        }
      }
    }
  }
  .result-wrap {
    margin: perS(10) 0 0 perS(25);
    position: relative;
    .tag {
      position: relative;
      margin-bottom: perS(0);
      .img {
        width: perS(70);
        height: auto;
      }
      .text {
        font-size: perS(12);
        line-height: perS(20);
        font-weight: 900;
        color: #fff;
        transform: rotate(-7deg);
        position: absolute;
        top: perS(6.5);
        left: perS(10);
      }
    }
    .list {
      width: perS(169);
      .item {
        display: flex;
        .van-icon {
          margin-right: perS(8);
          color: #46b13a;
        }
        .text {
          font-size: perS(8);
          line-height: perS(16);
          font-weight: 500;
          color: #000;
          .green {
            color: #46b13a;
          }
        }
      }
    }
    .bottom-img1 {
      position: absolute;
      width: perS(86);
      height: auto;
      right: perS(70);
      top: perS(60);
      z-index: 1;
    }
    .bottom-img2 {
      position: absolute;
      width: perS(100);
      height: auto;
      right: perS(35);
      top: perS(0);
    }
    .line-red {
      position: absolute;
      width: perS(119);
      height: auto;
      right: perS(-10);
      top: perS(65);
      z-index: 2;
    }
    .line-yellow {
      position: absolute;
      width: perS(32);
      height: auto;
      right: perS(140);
      top: perS(30);
    }
  }
}
.page-end {
  position: relative;
  overflow: hidden;
  width: 100vw;
  height: 100%;
  background-image: url(https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/bg-green.png);
  background-size: 100% auto;
  background-repeat: no-repeat;
  .logo {
    width: perS(90);
    height: auto;
    position: absolute;
    top: 10vh;
    right: perS(28);
  }
  .main-wrap {
    position: relative;
    margin-top: 26vh;
    .note1 {
      position: absolute;
      top: perS(-25);
      left: perS(55);
      width: perS(19);
      height: auto;
    }
    .note2 {
      position: absolute;
      top: perS(235);
      left: perS(325);
      width: perS(30);
      height: auto;
    }
    .note3 {
      position: absolute;
      top: perS(65);
      left: perS(85);
      width: perS(15);
      height: auto;
    }
    .note4 {
      position: absolute;
      top: perS(-15);
      left: perS(255);
      width: perS(35);
      height: auto;
    }
    .end-logo {
      display: block;
      width: perS(163);
      height: auto;
      margin: 0 auto;
    }
    .phone-text {
      text-align: center;
      font-size: perS(22);
      color: #fff;
      line-height: perS(40);
      font-weight: 700;
      margin-top: perS(30);
      .small {
        font-size: perS(24);
        font-weight: 400;
      }
    }
  }
  .qr-code-wrap {
    margin-top: perS(100);
    display: flex;
    align-items: center;
    .qr-code {
      width: perS(92);
      height: perS(92);
      margin: 0 perS(10);
    }
    .text-wrap {
      flex: 1;
      color: #fff;
      text-align: left;
      .text1 {
        font-size: perS(14);
      }
      .line {
        height: perS(3);
        background: #fff;
        width: perS(187);
        margin: perS(8) 0 perS(12) 0;
      }
      .text2 {
        font-size: perS(10);
        line-height: perS(18);
      }
    }
  }
}
@media screen and (max-height: 720px) {
  .page-home {
    .logo {
      top: 2vh;
    }
    .text-wrap {
      margin-top: 14vh;
    }
  }
  .common-title-page {
    .logo {
      top: 2vh;
    }
    .number {
      margin-top: 16vh;
    }
  }
  .page1-1 {
    .logo {
      top: 2vh;
    }
    .title {
      margin-top: 8vh;
      margin-bottom: 4vh;
    }
  }
  .page1-2 {
    .logo {
      top: 2vh;
    }
    .title {
      margin-top: 8vh;
      margin-bottom: 4vh;
    }
  }
  .page2-1 {
    .logo {
      top: 2vh;
    }
    .base-pro-img {
      margin-top: 7vh;
    }
  }
  .page2-2 {
    .logo {
      top: 2vh;
    }
    .title {
      margin-top: 7vh;
      margin-bottom: 5vh;
    }
    .course-list {
      .item {
        .bg {
          margin-bottom: 4vh;
        }
      }
    }
  }
  .page2-3 {
    .logo {
      top: 2vh;
    }
    .age-wrap {
      margin-top: 5vh;
    }
    .main-student {
      top: 18vh;
    }
    .result-wrap {
      margin-top: 2vh;
    }
    .group-type {
      margin-top: 0;
    }
    .common-video-button {
      margin-top: 0;
    }
  }
  .page2-4 {
    .logo {
      top: 2vh;
    }
    .age-wrap {
      margin-top: 2vh;
    }
    .main-student {
      top: 20vh;
    }
    .group-type {
      margin-top: 0;
      .item {
        .text {
          line-height: 3vh;
        }
      }
    }
    .main-desc {
      .desc {
        padding: 1vh;
      }
    }
    .course-wrap {
      .list {
        padding: 1vh;
        .item {
          margin-bottom: 1vh;
        }
      }
    }
    .common-video-button {
      margin-top: 0;
    }
  }
  .page-end {
    .logo {
      top: 2vh;
    }
    .main-wrap {
      margin-top: 16vh;
    }
    .qr-code-wrap {
    }
  }
}
.common-video-button {
  display: inline-block;
  position: relative;
  padding: 10px;
  margin: perS(10) 0 0 perS(25);
  .border1 {
    border: 1px solid #ea5d40;
    border-radius: 16px;
    animation: 0.8s ease-in-out 0.6s videoBorderButtonFade infinite;
    position: absolute;
    top: 3px;
    left: 3px;
    width: 95px;
    height: 39px;
    display: none;
  }
  .border2 {
    border: 0.8px solid #ea5d40;
    border-radius: 15px;
    animation: 1s ease-in-out 0.3s videoBorderButtonFade infinite;
    position: absolute;
    top: 5px;
    left: 5px;
    width: 90px;
    height: 35px;
    display: none;
  }
  .border3 {
    border: 0.8px solid #ea5d40;
    border-radius: 14px;
    animation: 1s ease-in-out 0s videoBorderButtonFade infinite;
    position: absolute;
    top: 8px;
    left: 7px;
    width: 86px;
    height: 29px;
    display: none;
  }
  .content {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #ea5d40;
    border-radius: 15px;
    width: 82px;
    height: 26px;
    animation: 1.5s ease-in-out 0s videoBorderButtonScale infinite;
    .van-icon {
      font-size: 12px;
      margin-right: 4px;
      color: #fff;
    }
    .text {
      color: #fff;
      font-size: 12px;
      line-height: 12px;
      font-weight: 700;
    }
  }
}
@keyframes videoBorderButtonScale {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1);
  }
  60% {
    transform: scale(1.2);
  }
  70% {
    transform: scale(1);
  }
  80% {
    transform: scale(1);
  }
  90% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes videoBorderButtonFade {
  0% {
    opacity: 0.6;
  }
  50% {
    opacity: 0.1;
  }
  100% {
    opacity: 0.6;
  }
}
@keyframes homeArrowSwing {
  0% {
    transform: translate3d(0, 0, 0);
  }
  50% {
    transform: translate3d(0, -5%, 0);
  }
  100% {
    transform: translate3d(0, 0, 0);
  }
}
</style>
